import axiosInstance from './axiosInstance';

export const getAllCommissionProgress = (archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetAllCommissionProgress?archived=${archived}`);

export const getCommissionProgressByAgentId = (agentId, archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByAgentId?agentId=${agentId}&archived=${archived}`);

export const getCommissionProgressByGroupName = (groupName, archived = false) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByGroupName?groupName=${encodeURIComponent(groupName)}&archived=${archived}`);

export const getCommissionProgressBySalesIdAgentId = (salesId, agentId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressBySalesIdAgentId?salesId=${salesId}&agentId=${agentId}`);

export const getCommissionProgressByCommPayType = (commPayType) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressByCommPayType?commPayType=${commPayType}`);

// Referral fees need their own call rather than ByCommPayType('RefC'): an Astern-borne
// fee has NO CommissionProgress row by design, so the generic query would return only
// the agent-borne exception and hide the default.
export const getReferralFees = () =>
    axiosInstance.get('/CommissionProgress/GetReferralFees');
// A selling agent's own slice — referrals on sales they sold, scoped to the caller with no
// id to pass, and with the referrer's bank details stripped. (user 2026-10-14)
export const getMyReferralFees = () =>
    axiosInstance.get('/CommissionProgress/GetMyReferralFees');
// The REFERRER's own slice — the sales they introduced. Not the same list as above: that
// one is keyed on the selling agent, and a Referral-role user is never one. (user 2026-10-18)
export const getMyReferredSales = () =>
    axiosInstance.get('/CommissionProgress/GetMyReferredSales');

// The share link's authenticated half — the referrer's own code and introductions.
// Its PUBLIC half lives in referralLinkApi.js, on plain axios, beside signApi.
// (user 2026-10-18)
export const getMyReferralLink = () =>
    axiosInstance.get('/ReferralLink/MyLink');
export const getMyReferralEnquiries = () =>
    axiosInstance.get('/ReferralLink/MyEnquiries');

export const updateCommissionProgress = (data) =>
    axiosInstance.put("/CommissionProgress/UpdateCommissionProgress", data);

export const getCommissionProgressById = (commProgressId) =>
    axiosInstance.get(`/CommissionProgress/GetCommissionProgressById?commProgressId=${commProgressId}`);
// Bulk payout (2026-08-20). Call with dryRun:true first to get the preview the dialog
// shows, then again with dryRun:false to commit. The gate is enforced server-side —
// this is only the transport.
export const bulkPayout = (payload) =>
    axiosInstance.post('/CommissionProgress/BulkPayout', payload);
